import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AlertModule } from './alert/alert.module';

import { throwIfAlreadyLoaded } from './guards/module-import.guard';

import { ExceptionService } from './exception.service';

// imports: imports the module's exports. which is usually declarables and providers
// in our case the spinner has no providers.
//
// exports: exports modules AND components/directives/pipes that other modules may want to use
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AlertModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AlertModule
  ],
  declarations: [],
  providers: [
    ExceptionService
  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts